let lastId = 0;

export default function () {
  lastId++;
  return `${lastId}`;
}
